import React from 'react'
import { connect } from 'react-redux'
import { Spinner } from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../../components/AlertMessage'
import importsActions from '../../../integrations/actions'

class Step3 extends React.Component {
  componentDidMount() {
    const {
      branch,
      dispatch,
      paths,
      platform,
      repository
    } = this.props

    dispatch(importsActions.checkPaths(platform, repository.value, paths, branch))
  }

  render() {
    const {
      checkingPathsError,
      checkingPathsStatus,
      creationError,
      creationStatus,
      t
    } = this.props

    return (
      <div className="d-flex flex-row justify-content-center align-items-center my-3">
        {checkingPathsStatus === 'checking' && (
          <>
            <Spinner className="text-secondary" />
            <span className="ms-3">{t('ProjectCreationModal.Step3.checkingSourceCode')}</span>
          </>
        )}

        {checkingPathsStatus === 'failed' && (
          <AlertMessage>
            {typeof checkingPathsError === 'string'
              ? checkingPathsError
              : t('ProjectCreationModal.Step3.errors.pathsCheckFailed')}
          </AlertMessage>
        )}

        {creationStatus === 'creating' && (
          <>
            <Spinner className="text-secondary" />
            <span className="ms-3">{t('ProjectCreationModal.Step3.creatingProject')}</span>
          </>
        )}

        {creationStatus === 'failed' && (
          <AlertMessage>
            {typeof creationError === 'string'
              ? creationError
              : t('ProjectCreationModal.Step3.errors.projectCreationFailed')}
          </AlertMessage>
        )}
      </div>
    )
  }
}

Step3.propTypes = {
  branch: PropTypes.string,
  checkingPathsError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  checkingPathsStatus: PropTypes.string,
  creationError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  creationStatus: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  paths: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  repository: PropTypes.shape({
    value: PropTypes.number
  }),
  t: PropTypes.func.isRequired
}

Step3.defaultProps = {
  branch: null,
  checkingPathsError: null,
  checkingPathsStatus: 'idle',
  creationError: null,
  creationStatus: 'idle',
  repository: null
}

const mapStateToProps = ({
  integrations: {
    checkingPathsError,
    checkingPathsStatus
  },
  projects: {
    creationError,
    creationStatus
  }
}) => ({
  checkingPathsError,
  checkingPathsStatus,
  creationError,
  creationStatus
})

export default withTranslation('ProjectsPage')(
  connect(mapStateToProps)(Step3)
)
